import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useField } from "formik";
import { Form as BTForm } from "react-bootstrap";

export default function ColorSelect({
  selectedValue,
  colors,
  changeCallback,
  open,
}) {
  const [isOpen, setOpen] = useState(open);

  const selectedColor = colors.find((color) => color.id === selectedValue);

  return (
    <div className="d-flex align-items-center justify-content-center position-relative flex-wrap category-colors w-100">
      <button
        className={`btn btn-light text-dark border border-dark d-flex align-items-center justify-content-center w-100`}
        type="button"
        onClick={() => setOpen(!isOpen)}
      >
        <div
          className={`rounded-circle shadow-sm mr-2 ui-color-bulb border border-dark`}
          style={{ backgroundColor: selectedColor?.value }}
        ></div>
        <span>Farbe auswählen</span>
        <FontAwesomeIcon icon={faChevronDown} size="sm" className="ml-2" />
      </button>
      {isOpen && (
        <div
          className="d-flex bg-white shadow-sm border w-auto p-2 rounded flex-wrap mt-2"
          style={{ marginTop: "6.2rem" }}
        >
          {colors.map((color) => (
            <div
              key={color.value}
              className={`rounded-circle shadow-sm m-1 ui-color-bulb ${
                selectedValue === color.value ? "active" : ""
              }`}
              style={{ backgroundColor: color.value }}
              onClick={() => {
                changeCallback(color.id);
                setOpen(false);
              }}
            ></div>
          ))}
        </div>
      )}
    </div>
  );
}

export function FormColorSelect({
  name,
  label,
  colors,
  open = false,
  onChange,
}) {
  const [field, meta, helpers] = useField(name);
  const { value } = field;
  const { setValue } = helpers;

  return (
    <BTForm.Group controlId={name}>
      <ColorSelect
        selectedValue={value}
        colors={colors}
        changeCallback={onChange ?? setValue}
        open={open}
      />
      {meta.touched && meta.error && (
        <span className="text-danger">{meta.error}</span>
      )}
    </BTForm.Group>
  );
}
